import { Checkbox, FlowPage, SPACING } from '@monthio/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const ConsentContainer = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: ${SPACING.m};

	> label {
		flex-shrink: 0;
		${(p) => p.theme.breakpoints.down('xs')} {
			align-self: baseline;
		}
	}
`

export const FlowBottomWithConsent: React.FC<{
	isConsentRequired: boolean
	isConsentGiven: boolean
	onConsentGivenChange: () => void
	onContinue: () => void
	canContinue: boolean
}> = ({
	isConsentGiven,
	isConsentRequired,
	onConsentGivenChange,
	onContinue,
	canContinue,
}) => {
	const { t } = useTranslation()

	return (
		<FlowPage.Footer
			additionalContent={
				isConsentRequired && (
					<ConsentContainer>
						<Checkbox
							aria-required="true"
							isSelected={isConsentGiven}
							onChange={onConsentGivenChange}
						>
							{t('bankSessionOverview-explicit-consent-text')}
						</Checkbox>
					</ConsentContainer>
				)
			}
			actions={
				<FlowPage.Cta disabled={!canContinue} onClick={onContinue}>
					{t('bankSessionOverview-noMoreBanks-button-text')}
				</FlowPage.Cta>
			}
		/>
	)
}
